import React, {FC} from 'react';

export type TBadgeTone = 'ok' | 'warn' | 'muted' | 'info';

const TONES: Record<TBadgeTone, string> = {
  ok: 'bg-[#e8f5ee] text-[#1f7a4c]',
  warn: 'bg-[#fdf1e3] text-[#95591a]',
  muted: 'bg-gray-100 text-gray-500',
  info: 'bg-[#efedfb] text-[#654dcb]',
};

export const Badge: FC<{tone: TBadgeTone; title?: string; children: React.ReactNode}> = ({tone, title, children}) => (
  <span title={title} className={`whitespace-nowrap rounded-full px-2 py-0.5 text-[11px] font-medium ${TONES[tone]}`}>
    {children}
  </span>
);
